// GomiMall Shopify Theme - Main JavaScript
// Korean Beauty & Skincare Store

(function() {
  'use strict';

  // ============================================================
  // SCROLL HEADER
  // ============================================================
  const header = document.querySelector('.gomi-header');
  if (header) {
    const handleScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  // ============================================================
  // MOBILE MENU
  // ============================================================
  const menuBtn = document.querySelector('.gomi-mobile-menu-btn');
  const mobileNav = document.querySelector('.gomi-mobile-nav');
  const mobileClose = document.querySelector('.gomi-mobile-nav-close');

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // ============================================================
  // PREDICTIVE SEARCH
  // ============================================================
  const searchInput = document.getElementById('gomiSearchInput');
  const searchResults = document.getElementById('gomiPredictiveResults');
  const zeroState = document.getElementById('gomiZeroStateSearch');
  let searchTimeout;

  if (searchInput && searchResults) {
    searchInput.addEventListener('focus', (e) => {
      const query = e.target.value.trim();
      if (query.length < 2 && zeroState) {
        zeroState.style.display = 'block';
        searchResults.style.display = 'none';
      }
    });

    searchInput.addEventListener('input', (e) => {
      clearTimeout(searchTimeout);
      const query = e.target.value.trim();
      
      if (query.length < 2) {
        searchResults.style.display = 'none';
        if(zeroState) zeroState.style.display = 'block';
        return;
      } else {
        if(zeroState) zeroState.style.display = 'none';
      }

      searchTimeout = setTimeout(async () => {
        try {
          const res = await fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=4`);
          const data = await res.json();
          const products = data.resources.results.products;
          
          if (products && products.length > 0) {
            let html = '<div style="font-size: 11px; text-transform: uppercase; color: var(--color-gray); margin-bottom: 12px; letter-spacing: 1px;">Products</div>';
            products.forEach(p => {
              html += `
                <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
                  <a href="${p.url}" style="display: flex; align-items: center; gap: 12px; flex: 1; text-decoration: none; color: inherit;">
                    ${p.image ? `<img src="${p.image}" alt="${p.title}" style="width: 48px; height: 48px; object-fit: cover; border-radius: 4px; flex-shrink: 0;">` : ''}
                    <div>
                      <div style="font-size: 13px; font-weight: 600;">${p.title}</div>
                      <div style="font-size: 12px; color: var(--color-primary);">${p.price}</div>
                    </div>
                  </a>
                  <button class="gomi-btn" style="padding: 6px 12px; font-size: 11px; min-width: 60px; height: fit-content;" onclick="gomiSearchAtc('${p.handle}', this)">ADD</button>
                </div>
              `;
            });
            html += `<a href="/search?q=${query}&type=product" style="display: block; text-align: center; font-size: 13px; font-weight: 600; text-decoration: underline; margin-top: 16px;">View all results</a>`;
            searchResults.innerHTML = html;
            searchResults.style.display = 'block';
          } else {
            searchResults.innerHTML = '<div style="font-size: 13px; color: var(--color-gray); text-align: center;">No products found</div>';
            searchResults.style.display = 'block';
          }
        } catch (err) {
          console.error('Predictive search error', err);
        }
      }, 300);
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!searchInput.contains(e.target) && !searchResults.contains(e.target) && (!zeroState || !zeroState.contains(e.target))) {
        searchResults.style.display = 'none';
        if(zeroState) zeroState.style.display = 'none';
      }
    });
  }

  // ============================================================
  // CART DRAWER
  // ============================================================
  const cartOverlay = document.querySelector('.gomi-cart-overlay');
  const cartDrawer = document.querySelector('.gomi-cart-drawer');
  const cartClose = document.querySelector('.gomi-cart-close');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');

  function openCart() {
    cartOverlay?.classList.add('open');
    cartDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    cartOverlay?.classList.remove('open');
    cartDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(btn => btn.addEventListener('click', openCart));
  cartOverlay?.addEventListener('click', closeCart);
  cartClose?.addEventListener('click', closeCart);

  // Escape key closes cart & mobile nav
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      mobileNav?.classList.remove('open');
      document.body.style.overflow = '';
    }
  });

  // ============================================================
  // CART API
  // ============================================================
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartUI(cart);
    } catch (err) {
      console.warn('Cart fetch failed:', err);
    }
  }

  function updateCartUI(cart) {
    // Free Gift Logic
    if (window.gomiSettings && window.gomiSettings.enableFreeGift && window.gomiSettings.freeGiftVariant) {
      const threshold = window.gomiSettings.freeGiftThreshold * 100;
      const giftVariant = window.gomiSettings.freeGiftVariant;
      const hasGift = cart.items.some(i => i.variant_id == giftVariant || i.id == giftVariant);
      
      // We don't count the gift price in the threshold if it somehow has a price
      const cartTotalNoGift = cart.items.reduce((acc, item) => {
        return (item.variant_id == giftVariant || item.id == giftVariant) ? acc : acc + item.final_line_price;
      }, 0);

      if (cartTotalNoGift >= threshold && !hasGift && cart.item_count > 0) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftVariant, quantity: 1 })
        }).then(() => fetchCart());
        return; // wait for next fetch
      } else if (cartTotalNoGift < threshold && hasGift) {
        const itemKey = cart.items.find(i => i.variant_id == giftVariant || i.id == giftVariant)?.key;
        if (itemKey) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: itemKey, quantity: 0 })
          }).then(() => fetchCart());
          return;
        }
      }
    }

    const countEl = document.querySelectorAll('.cart-count');
    const totalEl = document.querySelector('.gomi-cart-total-amount');
    const bodyEl = document.querySelector('.gomi-cart-body');

    countEl.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (totalEl) {
      totalEl.textContent = Shopify.formatMoney
        ? Shopify.formatMoney(cart.total_price, '{{ shop.money_format }}')
        : `AED ${(cart.total_price / 100).toFixed(2)}`;
    }

    if (bodyEl) {
      if (cart.item_count === 0) {
        bodyEl.innerHTML = `
          <div class="gomi-cart-empty">
            <div class="gomi-cart-empty-icon">🛍️</div>
            <p>Your cart is empty</p>
            <p style="font-size:12px;margin-top:6px;color:var(--color-gray-light)">Discover our Korean beauty essentials</p>
          </div>`;
      } else {
        bodyEl.innerHTML = cart.items.map(item => `
          <div class="gomi-cart-item" data-key="${item.key}">
            <img src="${item.image}" alt="${item.title}" style="width:64px;height:64px;object-fit:contain;border-radius:8px;background:var(--color-bg-section);padding:4px">
            <div style="flex:1;padding:0 12px">
              <div style="font-size:13px;font-weight:600;color:var(--color-dark);line-height:1.3">${item.product_title}</div>
              <div style="font-size:11px;color:var(--color-gray);margin:2px 0">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
              <div style="font-size:13px;font-weight:600;color:var(--color-primary);margin-top:4px">
                AED ${(item.price / 100).toFixed(2)}
              </div>
            </div>
            <div style="display:flex;flex-direction:column;align-items:flex-end;gap:8px">
              <button onclick="gomiRemoveCartItem('${item.key}')" style="font-size:18px;color:var(--color-gray-light);line-height:1" aria-label="Remove item">&times;</button>
              <div style="display:flex;align-items:center;gap:6px;border:1px solid var(--color-border);border-radius:20px;padding:2px 8px">
                <button onclick="gomiUpdateCartItem('${item.key}', ${item.quantity - 1})" style="font-size:16px;color:var(--color-dark)">−</button>
                <span style="font-size:13px;font-weight:600;min-width:16px;text-align:center">${item.quantity}</span>
                <button onclick="gomiUpdateCartItem('${item.key}', ${item.quantity + 1})" style="font-size:16px;color:var(--color-dark)">+</button>
              </div>
            </div>
          </div>
        `).join('');

        // Add spacing between items
        document.querySelectorAll('.gomi-cart-item').forEach(item => {
          item.style.cssText += 'display:flex;align-items:flex-start;gap:12px;padding:16px 0;border-bottom:1px solid var(--color-border)';
        });
        
        // --- Smart Cart Drawer Upsells ---
        const upsellContainer = document.createElement('div');
        upsellContainer.className = 'gomi-cart-upsell';
        upsellContainer.style.marginTop = '24px';
        upsellContainer.style.borderTop = '1px solid var(--color-border)';
        upsellContainer.style.paddingTop = '16px';
        bodyEl.appendChild(upsellContainer);
        
        fetch(`/recommendations/products.json?product_id=${cart.items[0].product_id}&limit=4`)
          .then(res => res.json())
          .then(data => {
            if(data.products && data.products.length > 0) {
              const cartIds = cart.items.map(i => i.product_id);
              const recs = data.products.filter(p => !cartIds.includes(p.id));
              
              if(recs.length > 0) {
                const rec = recs[0];
                upsellContainer.innerHTML = `
                  <div style="font-size: 11px; text-transform: uppercase; letter-spacing: 1px; color: var(--color-gray); margin-bottom: 12px; font-weight: 700;">Complete your routine</div>
                  <div style="display: flex; align-items: center; gap: 12px; background: var(--color-bg-alt); padding: 12px; border-radius: var(--radius-md);">
                    <img src="${rec.featured_image}" style="width: 48px; height: 48px; object-fit: cover; border-radius: 4px; border: 1px solid var(--color-border);">
                    <div style="flex: 1;">
                      <div style="font-size: 12px; font-weight: 600; line-height: 1.2; margin-bottom: 4px;">${rec.title}</div>
                      <div style="font-size: 11px; color: var(--color-primary);">AED ${(rec.price / 100).toFixed(2)}</div>
                    </div>
                    <button class="gomi-btn" style="padding: 6px 12px; font-size: 11px; min-width: 60px;" onclick="gomiAddUpsell(${rec.variants[0].id}, this)">Add</button>
                  </div>
                `;
              }
            }
          })
          .catch(err => console.error("Upsell fetch error", err));
      }
    }
  }

  window.gomiRemoveCartItem = async function(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    fetchCart();
  };

  window.gomiUpdateCartItem = async function(key, quantity) {
    if (quantity < 0) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    fetchCart();
  };

  window.gomiAddUpsell = async function(id, btn) {
    const originalText = btn.innerText;
    btn.innerText = '...';
    btn.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      });
      fetchCart();
    } catch(e) {
      btn.innerText = 'Error';
      setTimeout(() => { btn.innerText = originalText; btn.disabled = false; }, 2000);
    }
  };

  // ============================================================
  // ADD TO CART (product cards)
  // ============================================================
  document.addEventListener('click', async (e) => {
    const atcBtn = e.target.closest('[data-atc]');
    if (!atcBtn) return;

    const variantId = atcBtn.dataset.atc;
    if (!variantId) return;

    const original = atcBtn.textContent;
    atcBtn.textContent = '...';
    atcBtn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (res.ok) {
        atcBtn.textContent = '✓ Added!';
        atcBtn.style.background = '#4caf50';
        setTimeout(() => {
          atcBtn.textContent = original;
          atcBtn.style.background = '';
          atcBtn.disabled = false;
        }, 1800);
        fetchCart();
        openCart();
      } else {
        throw new Error('Failed');
      }
    } catch {
      atcBtn.textContent = 'Error';
      atcBtn.style.background = '#e74c3c';
      setTimeout(() => {
        atcBtn.textContent = original;
        atcBtn.style.background = '';
        atcBtn.disabled = false;
      }, 1800);
    }
  });

  // ============================================================
  // SCROLL ANIMATIONS (IntersectionObserver)
  // ============================================================
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));
  } else {
    // Fallback: show all
    document.querySelectorAll('[data-animate]').forEach(el => el.classList.add('in-view'));
  }

  // ============================================================
  // PRODUCT SLIDERS
  // ============================================================
  document.querySelectorAll('.gomi-slider-wrap').forEach(wrap => {
    const slider = wrap.querySelector('.gomi-slider');
    const prevBtn = wrap.querySelector('[data-slider-prev]');
    const nextBtn = wrap.querySelector('[data-slider-next]');

    if (!slider) return;

    const scrollAmount = () => {
      const card = slider.querySelector('.gomi-product-card');
      return card ? card.offsetWidth + 20 : 260;
    };

    prevBtn?.addEventListener('click', () => {
      slider.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn?.addEventListener('click', () => {
      slider.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });

  // ============================================================
  // EMAIL FORM
  // ============================================================
  const emailForm = document.querySelector('.gomi-email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = emailForm.querySelector('.gomi-email-input')?.value;
      const btn = emailForm.querySelector('.gomi-email-submit');

      if (!email || !btn) return;

      btn.textContent = 'Subscribing...';
      btn.disabled = true;

      // Shopify newsletter subscription
      try {
        await fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            form_type: 'customer',
            email,
            'contact[tags]': 'newsletter'
          })
        });
        btn.textContent = '🎉 Subscribed!';
        btn.style.background = '#4caf50';
      } catch {
        btn.textContent = 'Try Again';
        btn.disabled = false;
      }
    });
  }

  // ============================================================
  // WISHLIST (localStorage)
  // ============================================================
  const WISHLIST_KEY = 'gomi_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch { return []; }
  }

  function toggleWishlist(productId) {
    let list = getWishlist();
    const idx = list.indexOf(productId);
    if (idx === -1) {
      list.push(productId);
    } else {
      list.splice(idx, 1);
    }
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    return idx === -1; // true = added
  }

  document.addEventListener('click', (e) => {
    const wishBtn = e.target.closest('[data-wishlist]');
    if (!wishBtn) return;

    const productId = wishBtn.dataset.wishlist;
    const added = toggleWishlist(productId);
    wishBtn.style.color = added ? '#e74c3c' : '';
    wishBtn.title = added ? 'Remove from Wishlist' : 'Add to Wishlist';
  });

  // ============================================================
  // ANNOUNCEMENT BAR MARQUEE (if multiple messages)
  // ============================================================
  const announcement = document.querySelector('.gomi-announcement-text');
  if (announcement && announcement.dataset.messages) {
    const messages = JSON.parse(announcement.dataset.messages);
    if (messages.length > 1) {
      let idx = 0;
      setInterval(() => {
        announcement.style.opacity = '0';
        setTimeout(() => {
          idx = (idx + 1) % messages.length;
          announcement.textContent = messages[idx];
          announcement.style.opacity = '1';
        }, 300);
      }, 4000);
      announcement.style.transition = 'opacity 0.3s';
    }
  }

  // ============================================================
  // SMOOTH IMAGE LOADING
  // ============================================================
  document.querySelectorAll('img[loading="lazy"]').forEach(img => {
    img.style.opacity = '0';
    img.style.transition = 'opacity 0.4s ease';
    img.addEventListener('load', () => { img.style.opacity = '1'; });
    if (img.complete) { img.style.opacity = '1'; }
  });

  // ============================================================
  // COLLECTION FACETS (DROPDOWNS)
  // ============================================================
  const facetSummaries = document.querySelectorAll('.gomi-facet-summary');
  
  facetSummaries.forEach(summary => {
    summary.addEventListener('click', (e) => {
      const group = summary.closest('.gomi-facet-group');
      const isExpanded = summary.getAttribute('aria-expanded') === 'true';
      
      // Close others
      document.querySelectorAll('.gomi-facet-group').forEach(g => {
        g.classList.remove('open');
        g.querySelector('.gomi-facet-summary').setAttribute('aria-expanded', 'false');
      });

      if (!isExpanded) {
        group.classList.add('open');
        summary.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.gomi-facet-group')) {
      document.querySelectorAll('.gomi-facet-group').forEach(g => {
        g.classList.remove('open');
        g.querySelector('.gomi-facet-summary')?.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Initialize cart count on load
  fetchCart();

  // ============================================================
  const qvModal = document.getElementById('QuickViewModal');
  
  window.openQuickView = async function(handle) {
    if (!qvModal) return;
    
    // Show loading state
    document.getElementById('QVTitle').textContent = 'Loading...';
    document.getElementById('QVPrice').textContent = '';
    document.getElementById('QVImage').src = '';
    document.getElementById('QVLink').href = `/products/${handle}`;
    
    qvModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      
      document.getElementById('QVTitle').textContent = product.title;
      document.getElementById('QVPrice').textContent = typeof Shopify !== 'undefined' && Shopify.formatMoney
        ? Shopify.formatMoney(product.price, 'AED {{amount}}')
        : `AED ${(product.price / 100).toFixed(2)}`;
      
      if (product.images && product.images.length > 0) {
        document.getElementById('QVImage').src = product.images[0];
      }
      
      // Select first available variant
      const variant = product.variants[0];
      document.getElementById('QVVariantId').value = variant.id;
      
    } catch (err) {
      document.getElementById('QVTitle').textContent = 'Error loading product';
    }
  };

  window.closeQuickView = function() {
    if (qvModal) {
      qvModal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  const qvForm = document.getElementById('QVForm');
  if (qvForm) {
    qvForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = document.getElementById('QVVariantId').value;
      const btn = document.getElementById('QVAddBtn');
      
      const originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        
        if (res.ok) {
          btn.textContent = '✓ ADDED';
          btn.style.background = '#10B981';
          setTimeout(() => {
            closeQuickView();
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
            fetchCart();
            
            // Open Cart Drawer
            document.querySelector('.gomi-cart-drawer')?.classList.add('open');
            document.querySelector('.gomi-cart-overlay')?.classList.add('open');
          }, 800);
        } else {
          throw new Error('Failed');
        }
      } catch (err) {
        btn.textContent = 'ERROR';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      }
    });
  }

  window.gomiAddFbt = async function(variantId, btn) {
    if (!variantId) return;
    const originalText = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      
      if (res.ok) {
        btn.textContent = '✓';
        btn.style.background = '#10B981';
        btn.style.color = '#fff';
        btn.style.borderColor = '#10B981';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.style.color = '';
          btn.style.borderColor = '';
          btn.disabled = false;
          if (typeof fetchCart === 'function') fetchCart();
          document.querySelector('.gomi-cart-drawer')?.classList.add('open');
          document.querySelector('.gomi-cart-overlay')?.classList.add('open');
        }, 1000);
      } else {
        throw new Error('Failed');
      }
    } catch (err) {
      btn.textContent = 'ERR';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    }
  };

  window.gomiSearchAtc = async function(handle, btn) {
    if (!handle) return;
    const originalText = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;

    try {
      // Fetch product json to get variant ID
      const pRes = await fetch(`/products/${handle}.js`);
      if (!pRes.ok) throw new Error('Product not found');
      const product = await pRes.json();
      const variantId = product.variants[0].id;

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      
      if (res.ok) {
        btn.textContent = '✓';
        btn.style.background = '#10B981';
        btn.style.color = '#fff';
        btn.style.borderColor = '#10B981';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.style.color = '';
          btn.style.borderColor = '';
          btn.disabled = false;
          if (typeof fetchCart === 'function') fetchCart();
          document.querySelector('.gomi-cart-drawer')?.classList.add('open');
          document.querySelector('.gomi-cart-overlay')?.classList.add('open');
        }, 1000);
      } else {
        throw new Error('Failed to add');
      }
    } catch (err) {
      btn.textContent = 'ERR';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    }
  };

  // Linear congruential generator for daily pseudo-random shuffle
  function seededRandom(seed) {
    let s = seed % 2147483647;
    if (s <= 0) s += 2147483646;
    return function() {
      s = (s * 16807) % 2147483647;
      return (s - 1) / 2147483646;
    };
  }

  function shuffleWithSeed(array, seed) {
    const rng = seededRandom(seed);
    const copy = [...array];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  }

  // ============================================================
  // AUTOMATIC REAL-TIME NEW ARRIVALS SYNC (Daily 24h Shuffle & Latest First)
  // ============================================================
  async function initNewArrivalsSync() {
    const grids = document.querySelectorAll('.gomi-products-grid[data-new-arrivals="true"]');
    if (!grids.length) return;

    try {
      const res = await fetch('/products.json?limit=50');
      if (!res.ok) return;
      const data = await res.json();
      if (!data.products || !data.products.length) return;

      grids.forEach(grid => {
        const limit = parseInt(grid.getAttribute('data-limit') || '12', 10);
        const rawDeals = (grid.getAttribute('data-deals-handles') || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);

        // Filter out deals and special sets
        const validNewProducts = data.products.filter(p => {
          const h = (p.handle || '').toLowerCase();
          if (rawDeals.includes(h)) return false;
          if (h.startsWith('deal-') || h === 'deal1' || h === 'deal6') return false;
          if (p.tags && p.tags.some(t => {
            const tl = t.toLowerCase();
            return tl === 'deal' || tl === 'deals' || tl === 'sale_deal';
          })) return false;
          return true;
        });

        if (!validNewProducts.length) return;

        const nowSec = Math.floor(Date.now() / 1000);
        const TWO_DAYS_SEC = 2 * 86400; // Pinned window for newly listed products (48 hours)
        const currentDaySeed = Math.floor(Date.now() / 86400000); // Increments by 1 every 24 hours (1 day)

        // Step 1: Separate newly listed products (pinned to top) from the rest of the pool
        const pinnedNewProducts = [];
        const rotatablePool = [];

        validNewProducts.forEach(p => {
          const pubSec = Math.floor(new Date(p.published_at || p.created_at).getTime() / 1000);
          if (nowSec - pubSec < TWO_DAYS_SEC) {
            pinnedNewProducts.push(p);
          } else {
            rotatablePool.push(p);
          }
        });

        // Step 2: Deterministic daily shuffle of the rotatable pool every 24 hours
        const shuffledPool = shuffleWithSeed(rotatablePool, currentDaySeed);
        const targetProducts = [...pinnedNewProducts, ...shuffledPool].slice(0, limit);

        // Check what handles are currently rendered
        const currentCards = Array.from(grid.querySelectorAll('.gomi-product-card-premium'));
        const currentHandles = currentCards.map(c => {
          const link = c.querySelector('a.gomi-pc-image-link');
          return link ? link.getAttribute('href').replace('/products/', '').split('?')[0].toLowerCase() : '';
        });

        const targetHandles = targetProducts.map(p => p.handle.toLowerCase());
        const matches = targetHandles.length === currentHandles.length && 
                        targetHandles.every((th, i) => th === currentHandles[i]);

        if (matches) {
          // Already displaying exact target products for today
          return;
        }

        // Render latest products smoothly
        const html = targetProducts.map(p => {
          const currentVariant = (p.variants && p.variants[0]) || {};
          const priceNum = parseFloat(currentVariant.price || '0');
          const compareNum = parseFloat(currentVariant.compare_at_price || '0');
          const onSale = compareNum > priceNum;
          const isSoldOut = currentVariant.available === false || priceNum === 0;

          const formattedPrice = `AED ${priceNum.toFixed(2)}`;
          const formattedCompare = onSale ? `AED ${compareNum.toFixed(2)}` : '';
          const discountPct = onSale && compareNum > 0 ? Math.round(((compareNum - priceNum) / compareNum) * 100) : 0;

          const isVegan = (p.tags || []).some(t => t.toLowerCase() === 'vegan');
          const isBestseller = (p.tags || []).some(t => t.toLowerCase() === 'bestseller' || t.toLowerCase() === 'badge_bestseller');
          const isHot = (p.tags || []).some(t => t.toLowerCase().includes('hot'));

          const firstImage = (p.images && p.images[0] && p.images[0].src) || '';
          const pubSec = Math.floor(new Date(p.published_at || p.created_at).getTime() / 1000);

          const plainText = (p.body_html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
          const snippet = plainText ? plainText.split(' ').slice(0, 8).join(' ') : 'Premium Korean Skincare';

          return `
            <div class="gomi-product-card-premium" data-product-id="${p.id}" data-published-at="${pubSec}">
              <div class="gomi-pc-image-wrapper" style="position: relative;">
                <div class="gomi-pc-badges-left">
                  ${isBestseller && !isHot ? '<span class="gomi-pc-badge badge-bestseller">BESTSELLER</span>' : '<span class="gomi-pc-badge badge-new">NEW</span>'}
                </div>
                <div class="gomi-pc-badges-right" style="position: absolute; top: 10px; right: 10px; display: flex; flex-direction: column; gap: 5px; z-index: 2; align-items: flex-end;">
                  ${isHot || isBestseller ? '<div class="gomi-badge-hot" style="background: #ff4500; color: white; font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 4px; text-transform: uppercase; letter-spacing: 0.5px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">Hot Selling</div>' : ''}
                  ${onSale && discountPct > 0 ? `<div class="gomi-badge-discount" style="background: #e53935; color: white; font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 4px; letter-spacing: 0.5px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">-${discountPct}%</div>` : ''}
                  ${isVegan ? '<div class="gomi-vegan-icon" style="display: flex; align-items: center; gap: 4px; background: rgba(255,255,255,0.9); padding: 4px 8px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 21a9 9 0 0 0 9-9c0-1.5-.4-2.9-1-4.1l-8 13.1z"/><path d="M3.9 16.1l8-13.1c-3.5-.8-7 1-8.5 4.3-.8 1.8-1 3.8-.5 5.6 0 .5.3 1.1.7 1.5-.2.6.1 1.3.3 1.7z" fill="#4caf50" stroke="none"/></svg><span style="font-size: 10px; font-weight: 700; color: #2e7d32;">VEGAN</span></div>' : ''}
                </div>

                <a href="/products/${p.handle}" class="gomi-pc-image-link">
                  ${firstImage ? `<img width="500" height="500" src="${firstImage}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy">` : `<div style="width:100%;height:100%;background:#f5f5f5;"></div>`}
                </a>

                <div class="gomi-pc-actions">
                  <button type="button" class="gomi-pc-action-btn" onclick="openQuickView('${p.handle}')" aria-label="Quick View">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                  </button>
                  <button type="button" class="gomi-pc-action-btn" data-wishlist="${p.id}" aria-label="Wishlist">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                  </button>
                </div>
              </div>

              <div class="gomi-pc-info">
                <div class="gomi-pc-vendor">${p.vendor || 'GomiMall'}</div>
                <h3 class="gomi-pc-title"><a href="/products/${p.handle}">${p.title}</a></h3>
                <div class="gomi-pc-subtitle">${snippet}</div>
                <div class="gomi-pc-price" style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                  ${isSoldOut ? '<span class="gomi-pc-price-regular" style="font-weight: bold; color: #666;">Sold Out</span>' :
                    (onSale ? `<s class="gomi-pc-price-old" style="color: #999; font-size: 0.9em;">${formattedCompare}</s><span class="gomi-pc-price-new" style="color: #e53935; font-weight: bold;">${formattedPrice}</span>` :
                    `<span class="gomi-pc-price-regular" style="font-weight: bold;">${formattedPrice}</span>`)
                  }
                </div>
              </div>
            </div>
          `;
        }).join('');

        grid.innerHTML = html;
      });
    } catch (err) {
      console.warn('New Arrivals live sync error:', err);
    }
  }

  // ============================================================
  // AUTOMATIC CLIENT-SIDE FALLBACK / SYNC FOR BEST DEALS
  // ============================================================
  async function initDealsSync() {
    const dealsGrids = document.querySelectorAll('.gomi-products-grid[data-section-type="deals"]');
    if (!dealsGrids.length) return;

    for (const grid of dealsGrids) {
      const hasPlaceholders = grid.querySelector('.gomi-product-card') !== null;
      const realCards = grid.querySelectorAll('.gomi-product-card-premium');

      if (hasPlaceholders || realCards.length === 0) {
        try {
          const res = await fetch('/collections/deals/products.json?limit=50');
          if (!res.ok) continue;
          const data = await res.json();
          if (!data.products || !data.products.length) continue;

          const limit = parseInt(grid.getAttribute('data-limit') || '50', 10);
          const targetProducts = data.products.slice(0, limit);

          const html = targetProducts.map(p => {
            const currentVariant = (p.variants && p.variants[0]) || {};
            const priceNum = parseFloat(currentVariant.price || '0');
            const compareNum = parseFloat(currentVariant.compare_at_price || '0');
            const onSale = compareNum > priceNum;
            const isSoldOut = currentVariant.available === false || priceNum === 0;

            const formattedPrice = `AED ${priceNum.toFixed(2)}`;
            const formattedCompare = onSale ? `AED ${compareNum.toFixed(2)}` : '';
            const discountPct = onSale && compareNum > 0 ? Math.round(((compareNum - priceNum) / compareNum) * 100) : 0;

            const isVegan = (p.tags || []).some(t => t.toLowerCase() === 'vegan');
            const isBestseller = (p.tags || []).some(t => t.toLowerCase() === 'bestseller' || t.toLowerCase() === 'badge_bestseller');
            const isHot = (p.tags || []).some(t => t.toLowerCase().includes('hot'));

            const firstImage = (p.images && p.images[0] && p.images[0].src) || '';
            const pubSec = Math.floor(new Date(p.published_at || p.created_at).getTime() / 1000);

            const plainText = (p.body_html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
            const snippet = plainText ? plainText.split(' ').slice(0, 8).join(' ') : 'Special K-Beauty Deal';

            return `
              <div class="gomi-product-card-premium" data-product-id="${p.id}" data-published-at="${pubSec}">
                <div class="gomi-pc-image-wrapper" style="position: relative;">
                  <div class="gomi-pc-badges-left">
                    <span class="gomi-pc-badge badge-deal" style="background: #e53935; color: white; font-weight: 800; font-size: 10px; padding: 3px 8px; border-radius: 4px; letter-spacing: 0.5px;">BEST DEAL</span>
                  </div>
                  <div class="gomi-pc-badges-right" style="position: absolute; top: 10px; right: 10px; display: flex; flex-direction: column; gap: 5px; z-index: 2; align-items: flex-end;">
                    ${isHot || isBestseller ? '<div class="gomi-badge-hot" style="background: #ff4500; color: white; font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 4px; text-transform: uppercase; letter-spacing: 0.5px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">Hot Selling</div>' : ''}
                    ${onSale && discountPct > 0 ? `<div class="gomi-badge-discount" style="background: #e53935; color: white; font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 4px; letter-spacing: 0.5px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">-${discountPct}%</div>` : ''}
                    ${isVegan ? '<div class="gomi-vegan-icon" style="display: flex; align-items: center; gap: 4px; background: rgba(255,255,255,0.9); padding: 4px 8px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 21a9 9 0 0 0 9-9c0-1.5-.4-2.9-1-4.1l-8 13.1z"/><path d="M3.9 16.1l8-13.1c-3.5-.8-7 1-8.5 4.3-.8 1.8-1 3.8-.5 5.6 0 .5.3 1.1.7 1.5-.2.6.1 1.3.3 1.7z" fill="#4caf50" stroke="none"/></svg><span style="font-size: 10px; font-weight: 700; color: #2e7d32;">VEGAN</span></div>' : ''}
                  </div>

                  <a href="/products/${p.handle}" class="gomi-pc-image-link">
                    ${firstImage ? `<img width="500" height="500" src="${firstImage}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy">` : `<div style="width:100%;height:100%;background:#f5f5f5;"></div>`}
                  </a>

                  <div class="gomi-pc-actions">
                    <button type="button" class="gomi-pc-action-btn" onclick="openQuickView('${p.handle}')" aria-label="Quick View">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    </button>
                    <button type="button" class="gomi-pc-action-btn" data-wishlist="${p.id}" aria-label="Wishlist">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                    </button>
                  </div>
                </div>

                <div class="gomi-pc-info">
                  <div class="gomi-pc-vendor">${p.vendor || 'GomiMall'}</div>
                  <h3 class="gomi-pc-title"><a href="/products/${p.handle}">${p.title}</a></h3>
                  <div class="gomi-pc-subtitle">${snippet}</div>
                  <div class="gomi-pc-price" style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                    ${isSoldOut ? '<span class="gomi-pc-price-regular" style="font-weight: bold; color: #666;">Sold Out</span>' :
                      (onSale ? `<s class="gomi-pc-price-old" style="color: #999; font-size: 0.9em;">${formattedCompare}</s><span class="gomi-pc-price-new" style="color: #e53935; font-weight: bold;">${formattedPrice}</span>` :
                      `<span class="gomi-pc-price-regular" style="font-weight: bold;">${formattedPrice}</span>`)
                    }
                  </div>
                </div>
              </div>
            `;
          }).join('');

          grid.innerHTML = html;
        } catch (err) {
          console.warn('Deals fallback error:', err);
        }
      }
    }
  }

  // ============================================================
  // "NEW" BADGES & DAILY ROTATION FOR OTHER COLLECTIONS
  // ============================================================
  function initDynamicBadgesAndRotation() {
    const nowSec = Math.floor(Date.now() / 1000);
    const THIRTY_DAYS_SEC = 30 * 86400;

    // 1. Remove expired "NEW" badges (> 30 days old)
    document.querySelectorAll('.gomi-product-card-premium[data-published-at]').forEach(card => {
      const pubSec = parseInt(card.getAttribute('data-published-at'), 10);
      if (pubSec > 0) {
        const ageSec = nowSec - pubSec;
        if (ageSec >= THIRTY_DAYS_SEC) {
          const newBadge = card.querySelector('.badge-new');
          if (newBadge) {
            newBadge.remove();
          }
        }
      }
    });

    // 2. Client-side Daily Product Rotation (ONLY for non-new-arrivals grids)
    document.querySelectorAll('.gomi-products-grid[data-daily-rotate="true"]:not([data-new-arrivals="true"])').forEach(grid => {
      const cards = Array.from(grid.querySelectorAll('.gomi-product-card-premium'));
      if (cards.length <= 4) return;

      const currentDay = Math.floor(Date.now() / 86400000);
      const dailyOffset = (currentDay * 4) % cards.length;
      if (dailyOffset > 0) {
        const reordered = [
          ...cards.slice(dailyOffset),
          ...cards.slice(0, dailyOffset)
        ];
        reordered.forEach(card => grid.appendChild(card));
      }
    });
  }

  // Initialize on page load and on dynamic refresh
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initNewArrivalsSync();
      initDealsSync();
      initDynamicBadgesAndRotation();
    });
  } else {
    initNewArrivalsSync();
    initDealsSync();
    initDynamicBadgesAndRotation();
  }

})();

